var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPictureCongrat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 345,
    height: 360,
    viewBox: "0 0 345 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9815_32880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.294 229.318C168.074 230.486 181.025 238.883 196.963 243.926C222.554 252.03 246.431 248.495 261.253 246.148C286.039 242.223 299.966 240.015 313.38 227.924C316.326 225.263 335.231 207.692 335.97 182.13C336.794 153.666 314.054 150.61 312.138 116.125C311.379 102.387 312.716 94.4634 311.319 73.316C310.876 66.5396 309.172 58.5592 304.783 48.2016C290.082 13.4807 235.586 20.216 206.666 48.7007C177.747 77.1853 185.837 92.3333 157.777 110.301C129.717 128.268 117.927 147.677 131.487 185.423C136.253 198.688 143.493 211.87 154.614 220.602C159.27 224.25 162.92 227.1 166.294 229.318Z",
    fill: "#4A72FF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3589 279.714C58.2455 281.477 64.7444 294.223 75.2039 305.654C91.995 324.014 112.824 332.223 125.825 337.196C147.567 345.511 159.784 350.182 176.188 346.667C179.793 345.892 203.158 340.513 215.647 320.301C229.554 297.795 212.704 284.813 227.211 256.198C232.993 244.8 237.755 239.048 246.472 221.397C249.269 215.743 251.613 208.538 252.906 198.178C257.25 163.456 210.33 143.65 173.84 153.169C137.349 162.689 136.801 178.613 105.895 180.073C74.9893 181.534 56.4855 191.683 49.8169 228.31C47.4744 241.182 47.1577 255.132 52.0305 267.3C54.0738 272.388 55.6802 276.37 57.3589 279.714Z",
    fill: "#4A72FF",
    fillOpacity: 0.16
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_9815_32880)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.367,
    y: 114.391,
    width: 175.309,
    height: 185.047,
    rx: 11,
    fill: "#B7B7B7",
    fillOpacity: 0.21
  })), /*#__PURE__*/React.createElement("rect", {
    x: 106.758,
    y: 91.9609,
    width: 174.186,
    height: 194.019,
    rx: 10,
    fill: "#FCFDFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.755,
    cy: 345.98,
    rx: 2.80945,
    ry: 2.80374,
    fill: "#E2E8FD"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 319.716,
    cy: 308.972,
    rx: 2.80945,
    ry: 2.80374,
    fill: "#E2E8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.729 117.391C218.075 117.391 238.612 137.895 238.612 163.176C238.612 188.456 218.075 208.961 192.729 208.961C167.382 208.961 146.844 188.456 146.844 163.176C146.844 137.895 167.382 117.391 192.729 117.391Z",
    stroke: "url(#paint0_linear_9815_32880)",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 149.719,
    y1: 238.621,
    x2: 236.869,
    y2: 238.621,
    stroke: "#4B6AD8",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 149.719,
    y1: 252.078,
    x2: 236.869,
    y2: 252.078,
    stroke: "#4B6AD8",
    strokeWidth: 5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M178.852 146.702L195.503 165.915L244.153 108.276C247.796 104.381 253.519 108.536 250.657 112.949L202.787 185.907C199.145 190.58 194.202 191.099 190.039 186.426L165.844 157.606C161.161 150.856 173.129 141.249 178.852 146.702Z",
    fill: "url(#paint1_linear_9815_32880)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.5463 59C74.2099 59 65.5354 66.3427 64.1208 75.1243C61.7461 89.8671 95.1276 104.61 97.8901 89.9411C98.9817 84.1447 91.5811 80.0227 91.5811 71.6136C91.5811 64.0634 86.2168 59 79.5463 59Z",
    fill: "#E2E8FD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 75,
    r: 4,
    fill: "#E2E8FD"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85,
    cy: 133,
    r: 4,
    fill: "#E2E8FD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_9815_32880",
    x: 117.367,
    y: 110.391,
    width: 183.312,
    height: 193.047,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_9815_32880"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9815_32880",
    x1: 184.702,
    y1: 119.488,
    x2: 207.963,
    y2: 195.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B2775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B6AD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9815_32880",
    x1: 162.306,
    y1: 136.993,
    x2: 203.68,
    y2: 183.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.436243,
    stopColor: "#0B2775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4B6AD8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9815_32880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 345,
    height: 360,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictureCongrat);
export default __webpack_public_path__ + "static/media/pictureCongrat.e90e44512c6a9f781c80e116a16ce908.svg";
export { ForwardRef as ReactComponent };